<template>
    <EditPublication />
    
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
import EditPublication from "@/components/Publication/EditPublication.vue";
  
    export default defineComponent({
      name: "EditPublicationPage",
      components: {
        
        EditPublication,
      },
    });
  </script>